(function () {
  function initHero(hero) {
    if (hero.dataset.bjInit) return;
    hero.dataset.bjInit = '1';

    var slides = Array.prototype.slice.call(hero.querySelectorAll('.bj-hero-slide'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('.bj-dot'));
    if (!slides.length) return;

    var current = 0;
    var autoplay = hero.dataset.autoplay === 'true';
    var interval = parseInt(hero.dataset.interval, 10) || 5000;
    var timer = null;

    function show(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        restart();
      });
    });

    function restart() {
      if (!autoplay || slides.length < 2) return;
      clearInterval(timer);
      timer = setInterval(function () {
        show(current + 1);
      }, interval);
    }

    show(0);
    restart();
  }

  function initCarousel(wrap) {
    if (wrap.dataset.bjInit) return;
    wrap.dataset.bjInit = '1';

    var grid = wrap.querySelector('.bj-product-grid');
    var prevBtn = wrap.querySelector('.bj-prev');
    var nextBtn = wrap.querySelector('.bj-next');
    if (!grid || !prevBtn || !nextBtn) return;

    function scrollAmount() {
      var card = grid.querySelector('.bj-product-card');
      return card ? card.getBoundingClientRect().width + 24 : 300;
    }

    prevBtn.addEventListener('click', function () {
      grid.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      grid.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  }

  function initCollectionToolbar(root) {
    var filterToggle = root.querySelector('[data-filter-toggle]');
    var filterPanel = root.querySelector('[data-filter-panel]');

    if (filterToggle && filterPanel && !filterToggle.dataset.bjInit) {
      filterToggle.dataset.bjInit = '1';
      filterToggle.addEventListener('click', function () {
        filterPanel.classList.toggle('open');
      });
    }

    var sortSelect = root.querySelector('[data-sort-select]');
    if (sortSelect && !sortSelect.dataset.bjInit) {
      sortSelect.dataset.bjInit = '1';
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    if (filterPanel) {
      filterPanel.querySelectorAll('[data-filter-checkbox]').forEach(function (checkbox) {
        if (checkbox.dataset.bjInit) return;
        checkbox.dataset.bjInit = '1';
        checkbox.addEventListener('change', function () {
          filterPanel.requestSubmit ? filterPanel.requestSubmit() : filterPanel.submit();
        });
      });
    }
  }

  function initGallery(gallery) {
    if (gallery.dataset.bjInit) return;
    gallery.dataset.bjInit = '1';

    var mainImage = gallery.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!mainImage || !thumbs.length) return;

    var current = 0;

    function show(index) {
      var thumb = thumbs[index];
      if (!thumb) return;
      current = index;
      mainImage.src = thumb.dataset.image;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show((current - 1 + thumbs.length) % thumbs.length);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show((current + 1) % thumbs.length);
      });
    }
  }

  function initProductForm(root) {
    var form = root.querySelector('.bj-pdp-form');
    if (!form || form.dataset.bjInit) return;
    form.dataset.bjInit = '1';

    var variantsJson = root.querySelector('[data-variants-json]');
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var optionSelects = Array.prototype.slice.call(root.querySelectorAll('[data-option-select]'));
    var variantIdInput = form.querySelector('[data-variant-id-input]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var addToCartBtn = form.querySelector('[data-add-to-cart]');
    var addToCartLabel = form.querySelector('[data-add-to-cart-label]');

    function findVariant() {
      var selected = optionSelects.map(function (s) { return s.value; });
      if (!selected.length) return variants[0];
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      })[0];
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant || !variantIdInput) return;
      variantIdInput.value = variant.id;
      if (priceEl) {
        var html = variant.price_html;
        if (variant.compare_html) {
          html += ' <span class="bj-pdp-tax-note">（税込）</span> <s class="bj-pdp-compare-price">' + variant.compare_html + '</s>';
        } else {
          html += ' <span class="bj-pdp-tax-note">（税込）</span>';
        }
        priceEl.innerHTML = html;
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        if (addToCartLabel) addToCartLabel.textContent = variant.available ? 'カートに入れる' : '在庫切れ';
      }
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', updateUI);
    });

    var qtyInput = form.querySelector('[data-qty-input]');
    var qtyMinus = form.querySelector('[data-qty-minus]');
    var qtyPlus = form.querySelector('[data-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.min(99, val + 1);
      });
    }
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-accordion-toggle]').forEach(function (toggle) {
      if (toggle.dataset.bjInit) return;
      toggle.dataset.bjInit = '1';
      toggle.addEventListener('click', function () {
        var body = toggle.nextElementSibling;
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        if (body) body.classList.toggle('is-open');
      });
    });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('.bj-hero').forEach(initHero);
    scope.querySelectorAll('.bj-carousel-wrap').forEach(initCarousel);
    scope.querySelectorAll('.bj-pdp-gallery').forEach(initGallery);
    scope.querySelectorAll('.bj-pdp-main').forEach(initProductForm);
    initCollectionToolbar(scope);
    initAccordions(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Re-init when the merchant edits a section in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
